import { useMemo } from 'react'
import { useBackgroundJobsStore } from '../../../stores/backgroundJobsStore'

export function useGingerbreadJobs(jobIds: Array<string | null | undefined>) {
  const jobs = useBackgroundJobsStore(state => state.jobs)
  const key = jobIds.filter(Boolean).join('|')
  return useMemo(() => jobIds.filter((id): id is string => Boolean(id)).map(id => jobs.get(id)).filter(Boolean), [jobs, key])
}
